import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {GlobalService} from '../global.service';
import {AssetClassData} from '../../models/dashboard/asset-class-data';
import {REQUEST_URLS} from '../request-urls';

@Injectable()

export class DashboardService {
    public headers = {};
    constructor(private http: HttpClient,
                private globalService: GlobalService) {
        
        const accessToken: string = localStorage.getItem('__bt');
        this.headers['Authorization'] = `Bearer ${accessToken}`
    }

    public getAssetClassData(): Observable<AssetClassData[]> {
        return this.http
            .get(`${this.globalService.mainHost}${REQUEST_URLS.dashboard_asset_data}`, {headers: this.headers})
            .pipe(map(data => 
                data['Data']
                ));
    }

    //get country list for dashboard
    public get_country(): Observable<any> {
        return this.http
            .get(`${this.globalService.mainHost}${REQUEST_URLS.dashboard_country}`, {headers: this.headers})
            .pipe(map(data =>
                data['Data']
            ));
    }

    public get_country_stocks(val) {
        return this.http
            .get(`${this.globalService.mainHost}${REQUEST_URLS.dashboard_getStockMarket}/${val}`, {headers: this.headers})
            .pipe(map(data =>
                data['Data']
            ));
    }

    public getDashboardScreen(url) {
        return this.http
            .get(`${this.globalService.mainHost}${url}`, {headers: this.headers})
            .pipe(map(data =>
                data['Data']
            ));
    }
    public deleteDashboardScreen(url:string) {
        return this.http
            .delete(`${this.globalService.mainHost}${url}`, {headers: this.headers})
            .pipe(map(data =>
                data['Data']
            ));
    }
    public getStockMarketDataByName(id){
        return this.http
        .get(`${this.globalService.mainHost}/dashboard/getStockMarketDataByName/${id}`, {headers: this.headers})
        .pipe(map(data =>
            data['Data']
        ));
    }
}
